module.exports = __webpack_public_path__ + "assets/error-icon.43e577cf.svg";